import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { userIsAdmin } from '../../helpers/Auth';

const UploadsHeader = ({
  uploadsVisible,
  uploadsTotal,
  loading,
}) => {
  const intl = useIntl();

  return (
    <header className="page-header">
      <h2 className="page-title">
        <i className="far fa-upload" />
        {!userIsAdmin() ? intl.formatMessage({ defaultMessage: 'My Uploads' }) :
          intl.formatMessage({ defaultMessage: 'Uploads' })}
      </h2>
      <div className="header-actions users-actions">
        <div className="items-displaying users-displaying">
          {(!loading && uploadsTotal > 0) && (
            <span>
              {intl.formatMessage(
                { defaultMessage: '{uploadsVisible} of {uploadsTotal} uploads' },
                { uploadsVisible, uploadsTotal },
              )}
            </span>
          )}
        </div>
      </div>
    </header>
  );
};

UploadsHeader.propTypes = {
  uploadsVisible: PropTypes.string.isRequired,
  uploadsTotal: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default withRouter(UploadsHeader);
